var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10251_33351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00146 12.479V16.479",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00146 1.479V5.479",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50146 8.979H0.501465",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5015 8.979H11.5015",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50146 8.97949C2.50146 9.70176 2.64373 10.417 2.92013 11.0843C3.19653 11.7515 3.60166 12.3579 4.11238 12.8686C4.6231 13.3793 5.22942 13.7844 5.89671 14.0608C6.564 14.3372 7.27919 14.4795 8.00147 14.4795C8.72374 14.4795 9.43893 14.3372 10.1062 14.0608C10.7735 13.7844 11.3798 13.3793 11.8906 12.8686C12.4013 12.3579 12.8064 11.7515 13.0828 11.0843C13.3592 10.417 13.5015 9.70176 13.5015 8.97949C13.5015 8.25722 13.3592 7.54202 13.0828 6.87473C12.8064 6.20744 12.4013 5.60113 11.8906 5.09041C11.3798 4.57968 10.7735 4.17456 10.1062 3.89815C9.43893 3.62175 8.72374 3.47949 8.00147 3.47949C7.27919 3.47949 6.564 3.62175 5.89671 3.89815C5.22942 4.17456 4.6231 4.57968 4.11238 5.09041C3.60166 5.60113 3.19653 6.20744 2.92013 6.87473C2.64373 7.54202 2.50146 8.25722 2.50146 8.97949Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10251_33351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.980957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionIcon);
export default __webpack_public_path__ + "static/media/Region_icon.7984eefb.svg";
export { ForwardRef as ReactComponent };